<div
  [id]="content.options.id"
  class="progress-gauge"
  data-cy="progress-gauge"
></div>
